import React, { useState } from "react";
import {
  FaUserPlus,
  FaUsers,
  FaMoneyCheckAlt,
  FaHistory,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaGamepad,
  FaChartBar,
  FaTrophy,
  FaWallet,
  FaUserCircle,
  FaLock,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../providers/AuthContext";
import { handleCopyText } from "../../../helpers/functions";

const UserMyAccount = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <h1 className="text-[34px] font-bold mb-4">{t("My account")}</h1>

      {/* Form */}
      <div className="flex flex-wrap gap-x-6 w-full gap-y-4 mb-2">
        <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-4 md:mt-7">
          {/* First Name */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("First Name")}</label>
            <div className="flex items-center bg-[#fff] px-4 rounded-lg h-11">
              <input type="text" value="" className="bg-transparent focus:outline-none border-none flex-1" />
            </div>
          </div>

          {/* Last Name */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("Last Name")}</label>
            <div className="flex items-center bg-[#fff] px-4 rounded-lg h-11">
              <input type="text" value="" className="bg-transparent focus:outline-none border-none flex-1" />
            </div>
          </div>

          {/* Email */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("Email")}</label>
            <div className="flex items-center bg-[#fff] px-4 rounded-lg h-11">
              <i className="fa fa-envelope text-black" aria-hidden="true"></i>
              <input type="email" value="" className="bg-transparent focus:outline-none border-none flex-1" />
            </div>
          </div>

          {/* User ID */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("User ID")}</label>
            <div className="flex items-center bg-[#fff] px-4 py-2 rounded-lg h-11">
              <FaUserCircle className="text-primary-dark" size={20} />
              <input readOnly type="text" value={user.c_id} className="text-black bg-transparent focus:outline-none border-none flex-1" />
              <button className="text-primary/80" onClick={() => handleCopyText(user.c_id)}>
                📋
              </button>
            </div>
          </div>

          {/* Username */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("Username")}</label>
            <div className="flex items-center bg-[#595d60] px-4 rounded-lg h-11">
              <FaUserCircle className="text-primary-dark" size={20} />
              <input type="text" value={user.username} readOnly className="bg-transparent focus:outline-none border-none flex-1" />
            </div>
          </div>

          {/* Currency */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("Currency")}</label>
            <select className="bg-[#595d60] text-white px-4 py-2 rounded-lg w-full focus:outline-none h-11">
              <option value="TND">Tunisia Dinar</option>
              <option value="USD">US Dollar</option>
              <option value="EUR">Euro</option>
            </select>
          </div>

          {/* Mobile Number */}
          <div className="block">
            <label className="block mb-2 text-gray-400">{t("Mobile Number")}</label>
            <div className="flex bg-gray-700 px-4 py-2 h-11 rounded-lg">
              <span className="mr-2">🇵🇰</span>
              <input type="text" placeholder="+92" className="bg-transparent focus:outline-none flex-1 border-none" />
            </div>
          </div>
        </div>
      </div>

      {/* Update Button */}
      <div className="my-6">
        <button
          type="submit"
          className="bg-primary w-full font-medium px-3 py-2 mb-5 rounded-xl uppercase leading-3 text-sm transition duration-300 bg-fillButton h-10 mt-3 text-white disabled:opacity-50 hover:bg-primary/80"
        >
          {t("UPDATE")}
        </button>
      </div>
    </>
  );
};
export default UserMyAccount;
